import { createVariant } from '../../utils/createVariant';
export const FooterLink = createVariant({
    name: 'footer-link',
    tagName: 'a',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.captions['50FooterLink']), { color: theme.colors.blanc.textInverse, colorHover: theme.colors.medium.textLinkInverseHover, textDecoration: 'none', textDecorationHover: 'underline' })),
});
//# sourceMappingURL=FooterLink.js.map